import { Component, Inject, ViewContainerRef, TemplateRef  } from '@angular/core';
import { Http, Headers } from '@angular/http';
import { PagerService } from '../../services/shared/pager.service';
import { Rating } from '../../models/rating/rating.model';
import { RatingService } from '../../services/rating/rating.service';
import { ToastsManager } from 'ng2-toastr/ng2-toastr';
import { BsModalRef } from 'ngx-bootstrap/modal/bs-modal-ref.service';
import { BsModalService } from 'ngx-bootstrap/modal';
import { Customer } from '../../models/customer/customer-model'
import { UtilitiesService } from '../../services/shared/utilities.service';
import { RolePermissionService } from '../../services/role/role-permission.service';
import { Router } from '@angular/router';
import { ProductService } from '../../services/product/product.service';
import { Product } from '../../models/products/product.model';

@Component({
  selector: 'app-rating-list',
  templateUrl: './rating-list.component.html',
  styleUrls: ['./rating-list.component.css']
})
/** subscriber-list component*/
export class RatingListComponent {
  /** subscriber-list ctor */
  public ratingList: Rating[];
  public customer: Customer;
  public rowsOnPage: number;
  public arrRowsPerPage: number[];
  public productDetail = new Product();
  // pager object
  pager: any = {};
  searchQuery: string;
 // pageSize: number;
  // paged items
 // pagedItems: any[];
  filteredItems: any[];
  isActive: string="";
  star: number=-1;
  searchKeyword: string;
  modalRef: BsModalRef;
  config = {
    animated: true
  };
  /** subscriber-list ctor */
  constructor(private readonly ratingService: RatingService, private readonly pagerService: PagerService,
    public toastr: ToastsManager, vcr: ViewContainerRef, private modalService: BsModalService, private readonly utilitiesService: UtilitiesService,
    private readonly router: Router, private readonly rolePermissionService: RolePermissionService, private readonly ProductService: ProductService) {
    this.rolePermissionService.GetRolePermissions("ratingapproved").subscribe(
      data => {
        if (data != null) {
          var list = data.filter(function (element) {
            return (element.action == "list");
          });
          if (list.length > 0) {
            this.toastr.setRootViewContainerRef(vcr);
            this.getratings();
            //this.pageSize = 10;
            this.GetRowsPerPageList();
          }
          else {
            this.router.navigate(["/"]);
          }
        }
        else {
          this.router.navigate(["/"]);
        }
      }
    )
  }
  openModal(template: TemplateRef<any>, id) {
    if (id > 0) {
      this.ratingService.getCustomerInfo(id).subscribe(
        data => {
          if (data) {
            this.customer = data;
            if (this.customer.profileImagePath == null) {
              this.customer.profileImagePath = "http://ssl.gstatic.com/accounts/ui/avatar_2x.png";
            }
            this.modalRef = this.modalService.show(template, this.config);
          }
        }
      )
    }
    else {
      this.toastr.warning('User is not register', 'Info');
    }
  }
  openProductModal(productTemplate: TemplateRef<any>, id) {
    this.ProductService.GetProductById(id).subscribe(
      data => {
        if (data) {
          this.productDetail = data;
          this.modalRef = this.modalService.show(productTemplate, this.config);
        }
      }
    )
  }

  deleterating(id) {
    if (confirm("Are you sure to delete this rating?")) {
      this.ratingService.deleteRating(id).subscribe(
        response => {
          if (response) {
            this.toastr.success('Rating has been Deleted.', 'Success');
            setTimeout(() => {
              this.getratings();
            }, 2000);
          }
          else {
            this.toastr.error('Error occurred. Please try again', 'Error');
          }
        }
      )
    }
  }
  getratings() {
    this.ratingService.getRatings().subscribe(
      data => {
        if (data) {
          this.ratingList = data;
          this.filteredItems = data;
        //  this.setPage(1);
        }
        else {
          this.ratingList = null;
        }
      }
    )
  }

  OnFilterChange() {
    this.filteredItems = this.ratingList;

    if (this.isActive == "true") {
      this.filteredItems = this.filteredItems.filter(s => s.isActive == true);

    } else if (this.isActive == "false") {
      this.filteredItems = this.filteredItems.filter(s => s.isActive == false);
    }
    if (this.star > 0) {
      this.filteredItems = this.filteredItems.filter(s => s.rating == this.star);
    }

    if (this.searchKeyword != "" && this.searchKeyword != null) {
      this.filteredItems = this.utilitiesService.GetSearchedResult(this.filteredItems, this.searchKeyword);
    }
  }
  //getUserInfo(id) {
  //  this.ratingService.getUserInfo(id).subscribe(
  //    data => {
  //      this.ratingList = data
  //      this.setPage(1);
  //    }
  //  )
  //}
  ChangeStatus(id) {
    this.ratingService.UpdateActiveAndInactive(id).subscribe(
      data => {
        if (data) {
          this.toastr.success('Rating Status has been Updated.', 'Success');
          setTimeout(() => {
            this.getratings();
          }, 2000);
        } else {
          this.toastr.error('Not Updated.', 'Oops!');
        }
      }
    );

  }
  GetRowsPerPageList() {
    this.arrRowsPerPage = this.utilitiesService.GetRowsPerPageList();
    this.rowsOnPage = this.arrRowsPerPage[0];
  }

  //setPage(page: number) {

  //  // get pager object from service
  //  this.pager = this.pagerService.getPager(this.ratingList.length, page, this.pageSize);

  //  // get current page of items
  //  this.pagedItems = this.ratingList.slice(this.pager.startIndex, this.pager.endIndex + 1);
  //}
}



// WEBPACK FOOTER //
// ./src/app/ratings/rating-list/rating-list.component.ts